import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["flex items-center justify-center min-h-screen text-sm md:text-md xl:text-4xl", _ctx.errorStatus?'text-yellow-bar':'text-white'])
  }, _toDisplayString(_ctx.screenMessage), 3))
}